import { useCallback, useRef } from 'react';
import { useSearchStore } from './use-search-store';

export const useDoSearch = () => {
    const searchStore = useSearchStore();
    const abortControllerRef = useRef<AbortController | null>(null);

    const doSearch = useCallback(
        async (query: string, abortSignal: AbortSignal) => {
            await searchStore.doSearch(query, abortSignal);
        },
        [searchStore]
    );

    return useCallback(
        async (query: string) => {
            // Abort any ongoing search
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }

            // Create new abort controller for this search
            const abortController = new AbortController();
            abortControllerRef.current = abortController;

            try {
                await doSearch(query.trim(), abortController.signal);
            } catch (error) {
                // Only log non-abort errors
                if (error instanceof Error && error.name !== 'AbortError') {
                    // eslint-disable-next-line no-console
                    console.error('Search failed:', error);
                }
            } finally {
                // Only clear controller reference if this is still the current controller
                if (abortControllerRef.current === abortController) {
                    abortControllerRef.current = null;
                }
            }
        },
        [doSearch]
    );
};
